import styled from 'styled-components'
import { BLACK, BLUE } from '../../styles/colors'
import { GIVONIC } from '../../styles/fonts'

export const Container = (styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  position: relative;
  background: linear-gradient(180deg, #E4E7ED00 0%, #E4E7ED88 30%, #E4E7EDFF 50%, #E4E7EDFF 70%);
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const ContentContainer = (styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 16px;
  width: 55%;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const Title = (styled.span`
  color: ${BLACK};
  font-size: 18px;
  font-family: ${GIVONIC.bold};
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const ComingSoon = (styled.span`
  color: ${BLUE};
  font-size: 18px;
  font-family: ${GIVONIC.bold};
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const StarsImage = (styled.img`
  position: absolute;
  right: -32px;
  bottom: -32px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any
